import React from "react";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";
import colors from "../../Constants/colors";
import { useTranslation } from "react-i18next";
import { ComoInput } from "../Common/ComoInput";

interface SearchInputProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchTerm,
  setSearchTerm,
}) => {
  const { t } = useTranslation("myQuestionLists");
  return (
    <ComoInput
      placeholder={t("myQuestionLists.searchPlaceholder")}
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      multiline={false}
      maxRows={1}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: colors.gray400 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchInput;
